export const SUBSCRIPTION_PRODUCT_CRM = 'crm';
export const SUBSCRIPTION_PRODUCT_CM = 'cm';
export const SUBSCRIPTION_PRODUCT_INSIGHTS = 'insights';

type LikeAnOrganization = {
  subscriptionType: null | 'managed-service' | (string & {})
};

export function isManagedServiceSubscription(
  currentOrganization: null | LikeAnOrganization
): boolean {
  return currentOrganization?.subscriptionType === 'managed-service' ?? false;
}
